export default __webpack_public_path__ + "static/media/Img0017.efb72688.jpg";